import Content from '../types/enums/content';
import Event from './event';
import ImageUtils from '../utils/image';
import Plan from './plan';
import User from './user';
import { IAddonEventRequest } from '../types/interfaces/event';
import { store } from '../store/store';

class Addon extends Event {
  addon: string | undefined;
  isFree: boolean;
  logoColor: string | undefined;
  logoWhite: string | undefined;
  offerClaim: string | undefined;
  parentalControl: boolean | undefined;
  plan: Plan | undefined;
  planId: string | undefined;
  price: {
    monthly: number | null;
    annually: number | null;
  };

  constructor(request: IAddonEventRequest) {
    super({ ...request, type: Content.ADDON });
    this.addon = request.addon || request.id;
    this.logoColor = ImageUtils.getImage(request.logoColor, 'logo');
    this.logoWhite = ImageUtils.getImage(request.logoBlanco, 'logo');
    this.offerClaim = request.offerClaim;
    this.parentalControl = request.controlParental || false;
    this.planId =
      typeof request.plan === 'string'
        ? (request.plan as string)
        : request.plan?.id || request.plan?._id || '';
    this.isFree =
      ((request?.plan?.isFree && request?.plan?.incremental) ||
        (this.plan?.isFree && this.plan?.incremental)) ??
      false;
    this.plan = User.getPlan(this.planId);
    this.price = {
      monthly:
        parseFloat(
          this.plan?.planSubscription?.subscriptionPeriodicity?.mensual
            ?.amount || ''
        ) || null,
      annually:
        parseFloat(
          this.plan?.planSubscription?.subscriptionPeriodicity?.anual?.amount ||
            ''
        ) || null,
    };
  }

  checkAddon() {
    const { user } = store.getState();
    const plans = [user.planId]
      .concat(
        user.extraPlans?.map((extraPlan) => {
          return extraPlan.id || extraPlan._id;
        })
      )
      .filter((plan) => plan);
    if (plans.includes(this.planId)) {
      return true;
    }
    return false;
  }

  static checkAddon(planId: string) {
    const { user } = store.getState();
    const plans = [user.planId]
      .concat(
        user.extraPlans?.map((extraPlan) => {
          return extraPlan.id || extraPlan._id;
        })
      )
      .filter((plan) => plan);
    if (plans.includes(planId)) {
      return true;
    }
    return false;
  }
}

export default Addon;
